import {defineStore} from "pinia";
import {ref} from "vue";
import {useTapStore} from "@/stores/tapStore.js";

export const useColorStore = defineStore('color', () => {
    const tapApi = useTapApi();

    const init = ref(false)
    const lastTapId = ref()
    const colors = ref([])

    function add(color, id) {
        const tapStore = useTapStore()
        colors.value.unshift(color)
        if (colors.value.length > 16) {
            colors.value.pop()
        }
        try {
            tapApi.addColorToSwatch(id || tapStore.currentTap.id, color)
        } catch (e) {}
    }

    async function get(id) {
        const tapStore = useTapStore()
        const currentId = id || tapStore.currentTap.id
        if(!lastTapId || lastTapId.value !== currentId) {
            lastTapId.value = currentId
            init.value = false;
        }
        if(!init.value) {
            init.value = true;
            colors.value = await tapApi.getSwatchColors(lastTapId.value)
        }
        return colors.value;
    }

    return { add, get }
})
